<template>
  <div
    v-safe-html="clockText"
    class="text-no-wrap"
  />
</template>

<script>

export default {
  name      : 'RealTimeClock',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    displaySeconds: {
      type   : Boolean,
      default: false
    },
    classSeconds: {
      type   : String,
      default: ''
    }
  },
  data() {
    return {
      interval: null,
      date    : null,
      time    : null,
      second  : null
    }
  },
  computed: {
    clockText() {
      return `${this.time}${this.displaySeconds ? `<span class="${this.classSeconds}">:${this.second}</span>` : ''}`
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.startInterval()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.stopInterval()
  },
  destroyed() {
  },
  methods: {
    startInterval() {
      this.setDateTimeNow()
      this.interval = setInterval(() => {
        this.setDateTimeNow()
      }, 1000)
    },

    stopInterval() {
      clearInterval(this.interval)
    },

    setDateTimeNow() {
      const d = new Date()

      this.date = Intl.DateTimeFormat(this.$i18n.locale, {
        weekday: 'long',
        day    : 'numeric',
        month  : 'long'
      }).format(d)

      this.time = Intl.DateTimeFormat(this.$i18n.locale, {
        hour  : '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(d)

      this.second = this.padZero(d.getSeconds())
    },

    padZero(number) {
      if (number < 10) return '0' + number

      return number
    }
  }
}
</script>

<style scoped>

</style>
